import { useLang } from "@/i18n/LanguageContext";

export const Marquee = ({ dark = false }) => {
  const { t } = useLang();
  const list = [...t.marquee, ...t.marquee];
  return (
    <div
      className={`marquee overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-[var(--ink)] text-white" : "border-[var(--line)] bg-[var(--canvas-2)] text-[var(--ink)]"}`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {list.map((t, i) => (
          <span key={i} className="font-display flex items-center gap-8 pr-8 text-2xl font-semibold tracking-tight md:text-3xl">
            {t}
            <span className="h-2 w-2 rounded-full" style={{ background: i % 3 === 0 ? "var(--red)" : i % 3 === 1 ? "var(--gold)" : "var(--green)" }} />
          </span>
        ))}
      </div>
    </div>
  );
};
